import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getClientDocumentList, addClientDocument, deleteClientDocument, updateClientDocument, getClientDocumentType, } from "../slice/clientPanelDocumentSlice";
import { getClientPaymentList, getClientAppointmentNotes } from "../slice/clientPanelListPaymentSlice";

const ClientListPayment = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const { clientsDocument, loading, clientDocumentType } = useSelector((state) => state.clientDocument);
  const { clientsListPayment, clientAppointmentNotes } = useSelector((state) => state.clientListPayment);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [sortConfig, setSortConfig] = useState({ column: null, direction: "asc" });
  const clientToken = localStorage.getItem("client_access_token");

  const [form, setForm] = useState({
    document_type: "",
    file: null,
  });

  // useEffect(() => {
  //   dispatch(getClientAppointmentNotes(clientToken));
  // }, [dispatch]);
  const sortedData = [...(Array.isArray(clientsListPayment) ? clientsListPayment : [])].sort((a, b) => {
//   if (sortConfig.column === null) return 0;

//   const key = sortConfig.column;
//   const valA = a[key] ?? "";
//   const valB = b[key] ?? "";

//   if (!isNaN(valA) && !isNaN(valB)) {
//     return sortConfig.direction === "asc"
//       ? valA - valB
//       : valB - valA;
//   } else {
//     return sortConfig.direction === "asc"
//       ? valA.toString().localeCompare(valB.toString())
//       : valB.toString().localeCompare(valA.toString());
//   }
});

    console.log(sortedData);
    

//    const handleSort = (columnKey) => {
//       let direction = "asc";
//       if (sortConfig.column === columnKey && sortConfig.direction === "asc") {
//          direction = "desc";
//       }
//       setSortConfig({ column: columnKey, direction });
//    };

  useEffect(() => {
    if (showModal) {
      document.body.classList.add("modal-open");
      document.body.style.overflow = "hidden";
    } else {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
    }
  
    return () => {
      // Cleanup on unmount
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
    };
  }, [showModal]);

  const handleFormChange = (e) => {
    const { name, value, files } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  useEffect(() => {
    dispatch(getClientPaymentList(clientToken));
    // dispatch(getClientDocumentList(clientToken));
    dispatch(getClientDocumentType());
  }, [dispatch]);

    // console.log("clientsDocument", clientsDocument);
    // console.log("clientDocumentType", clientDocumentType);
    // console.log("clientsListPayment", clientsListPayment);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

//   const handleAddSubmit = async () => {

//     if (!form.document_type) {
//     toast.error("Please select a document type", {
//       position: "top-right",
//       autoClose: 2000,
//       style: { fontSize: "0.85rem" },
//     });
//     return;
//   }

//   if (!form.file) {
//     toast.error("Please upload a document file", {
//       position: "top-right",
//       autoClose: 2000,
//       style: { fontSize: "0.85rem" },
//     });
//     return;
//   }

//     const formData = new FormData();
//     formData.append("file_type", form.document_type);
//     formData.append("file_path", form.file);

//     const result = await dispatch(addClientDocument({ token: clientToken, formData }));
//     if (result.meta.requestStatus === "fulfilled") {
//       toast.success("Document added successfully", {
//         position: "top-right",
//           autoClose: 2000,
//           style: { fontSize: "0.85rem" },
//       });
//       handleCloseAddDocumentModal();
//       dispatch(getClientDocumentList(clientToken));
//     } else {
//       toast.error("Failed to add document", {
//         position: "top-right",
//           autoClose: 2000,
//           style: { fontSize: "0.85rem" },
//       });
//     }
//   };

//   const handleUpdateSubmit = async () => {

//     if (!form.document_type) {
//     toast.error("Please select a document type", {
//       position: "top-right",
//       autoClose: 2000,
//       style: { fontSize: "0.85rem" },
//     });
//     return;
//   }

//     const formData = new FormData();
//     formData.append("file_type", form.document_type);
//     if (form.file) {
//       formData.append("file_path", form.file);
//     }

//     const result = await dispatch(updateClientDocument({
//       token: clientToken,
//       documentData: formData,
//       documentId: selectedDocument.id,
//     }));

//     if (result.meta.requestStatus === "fulfilled") {
//       toast.success("Document updated successfully", {
//         position: "top-right",
//           autoClose: 2000,
//           style: { fontSize: "0.85rem" },
//       });
//       handleCloseEditDocumentModal();
//       dispatch(getClientDocumentList(clientToken));
//     } else {
//       toast.error("Failed to update document", {
//         position: "top-right",
//           autoClose: 2000,
//           style: { fontSize: "0.85rem" },
//       });
//     }
//   };

//   const handleAddDocumentModel = () => {
//     setForm({ document_type: "", file: null });
//     setShowAddModal(true);
//   };

//   const handleCloseAddDocumentModal = () => {
//     setShowAddModal(false);
//   };

//   const handleEditDocumentModel = (document) => {
//     setSelectedDocument(document);
//     setForm({
//       document_type: document.file_type,
//       file: null, // New file to be uploaded
//     });
//     setShowEditModal(true);
//   };

//   const handleCloseEditDocumentModal = () => {
//     setShowEditModal(false);
//   };

//   const handleDeleteDocument = async (documentId) => {
//     const confirmed = window.confirm("Are you sure you want to delete this document?");
//     if (!confirmed) return;

//     const result = await dispatch(deleteClientDocument({ token: clientToken, documentId }));

//     if (result.meta.requestStatus === "fulfilled") {
//       toast.success("Document deleted successfully", {
//         position: "top-right",
//         autoClose: 2000,
//         style: { fontSize: "0.85rem" },
//       });
//       dispatch(getClientDocumentList(clientToken)); // Refresh list
//     } else {
//       toast.error("Failed to delete document", {
//         position: "top-right",
//         autoClose: 2000,
//         style: { fontSize: "0.85rem" },
//       });
//     }
//   };
  const handleShowModel = (id, document) => {
    console.log("document", document);
    setSelectedDocument(document);
    setShowModal(true);
    dispatch(getClientAppointmentNotes(id));
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
    <style>{`
      .modal-backdrop-custom {
          position: fixed;
          top: 0;
          left: 0;
          z-index: 1040;
          width: 100vw;
          height: 100vh;
          background-color: rgba(0, 0, 0, 0.5);
      }
    `}
    </style>

    {showModal && <div className="modal-backdrop-custom"></div>}
      {/* <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="mb-3">List of Documents</h2>
          <button className="btn btn-sm btn-primary" onClick={handleAddDocumentModel}>Add Document</button>
        </div>
        
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>File Type</th>
              <th>File Path</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(clientsDocument) && clientsDocument.length > 0 ? (
              clientsDocument.map((document) => (
                <tr key={document.id}>
                  <td>{document.file_type}</td>
                  <td>{document.file_path}</td>
                  <td>
                    {(() => {
                      const date = new Date(document.created_at);
                      const formattedDate = date.toLocaleDateString('en-US', {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric',
                      });

                      const formattedTime = date.toLocaleTimeString('en-US', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true,
                      });

                      return `${formattedDate} ${formattedTime}`;
                    })()}
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => handleEditDocumentModel(document)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDeleteDocument(document.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2">No images found.</td>
              </tr>
            )}
          </tbody>
        </table>
        {showAddModal && (
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add Document</h5>
                  <button type="button" className="btn-close" onClick={handleCloseAddDocumentModal} aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="document_type" className="form-label">Document Type:</label>
                      <select
                        className="form-control"
                        id="document_type"
                        name="document_type"
                        value={form.document_type}
                        onChange={handleFormChange}
                      >
                        <option value="">Select Document Type</option>
                          {clientDocumentType &&
                            Object.entries(clientDocumentType).map(([key, value]) => (
                              <option key={key} value={key}>
                                {value}
                              </option>
                          ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="file" className="form-label">File:</label>
                      <input
                        type="file"
                        className="form-control"
                        id="file"
                        name="file"
                        onChange={handleFormChange}
                      />
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={handleCloseAddDocumentModal}>Close</button>
                  <button className="btn btn-primary" onClick={handleAddSubmit}>Add</button>
                </div>
              </div>
            </div>
          </div>
        )}
        {showEditModal && (
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Update Document</h5>
                    <button type="button" className="btn-close" onClick={handleCloseEditDocumentModal} aria-label="Close"></button>
                  </div>
                  <div className="modal-body">
                    <form>
                      <div className="mb-3">
                        <label htmlFor="document_type" className="form-label">Document Type:</label>
                        <select
                          className="form-control"
                          id="document_type"
                          name="document_type"
                          value={form.document_type}
                          onChange={handleFormChange}
                        >
                          <option value="">Select Document Type</option>
                          {clientDocumentType &&
                            Object.entries(clientDocumentType).map(([key, value]) => (
                              <option key={key} value={key}>
                                {value}
                              </option>
                          ))}
                        </select>
                      </div>
                      <div className="mb-3">
                        <label htmlFor="file" className="form-label">File:</label>
                        <input
                          type="file"
                          className="form-control"
                          id="file"
                          name="file"
                          onChange={handleFormChange}
                        />
                        {selectedDocument?.file_path && (
                          <small className="text-muted">Existing file: {selectedDocument.file_path.split('/').pop()}</small>
                        )}
                      </div>
                    </form>
                  </div>
                  <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={handleCloseEditDocumentModal}>Close</button>
                    <button className="btn btn-primary" onClick={handleUpdateSubmit}>Update</button>
                  </div>
                </div>
              </div>
            </div>
            )}
        </div> */}

        <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat d-flex">
          My Subscriptions
          {/* <button className="btn btn-danger ms-auto py-2" onClick={handleAddDocumentModel}>
            <i className="fa fa-user-plus me-1"></i> Add Document
          </button> */}
          </h4>
          <div className="table-responsive">
            {loading ? (
                <p>Loading Documents...</p>
              ) : !clientsListPayment || !Array.isArray(clientsListPayment) || clientsListPayment.length === 0 ? (
                <p>No document found.</p>
              ) : (
            <table className="table table-striped table-bordered align-middle" id="servicesTable">
              <thead>
                <tr>
                  <th className="font-weight-semibold" /*onClick={() => handleSort("file_type")}*/>Provider <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" /*onClick={() => handleSort("file_path")}*/>Service <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" /*onClick={() => handleSort("file_path")}*/>Status <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" /*onClick={() => handleSort("created_at")}*/>Start Date <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" /*onClick={() => handleSort("created_at")}*/>End Date <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" /*onClick={() => handleSort("created_at")}*/>Type <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" /*onClick={() => handleSort("created_at")}*/>Subscription <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" /*onClick={() => handleSort("created_at")}*/>Action <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((document, index) => {
                  const appointment = document.serviceAppointment?.[0]; // Get first appointment if exists
                  const appointmentType =
                    appointment?.type === 'S'
                      ? 'Subscription'
                      : appointment?.type === 'H'
                      ? 'Hourly'
                      : '—';

                  return (
                    <tr key={document.id || index}>
                      <td>{document.provider?.contact_name || '—'}</td>
                      <td>{document.serviceProviderPay?.service_name || '—'}</td>
                      <td>{document.status || '—'}</td>
                      <td>{document.start_date || '—'}</td>
                      <td>{document.end_date || '—'}</td>
                      <td>{appointmentType}</td>
                      <td>
                        <a 
                          href={`${process.env.REACT_APP_CLIENT_INVOICE_BACKEND_URL}/${document.invoice}`} 
                          target="_blank" 
                          rel="noopener noreferrer"
                        >
                          {document.invoice}
                        </a>
                      </td>
                      <td><button className="btn btn-custom-primary me-2" onClick={() => handleShowModel(document.id, document)}>Details</button></td>
                    </tr>
                  );
                })}
              </tbody>
          </table>
           )}
        </div>
        
        
      </div>
            {showModal && (
        <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Appointment Notes</h5>
                <button type="button" className="btn-close" onClick={handleCloseModal} aria-label="Close"></button>
              </div>
              <div className="modal-body">
                {/* Row for Client - Service - Provider */}
                <div className="row mt-3 text-center">
                  <div className="col-md-4 text-start">
                    <strong>Client:</strong> {selectedDocument.client?.first_name} {selectedDocument.client?.last_name}
                  </div>
                  <div className="col-md-4">
                    <strong>Service:</strong> {selectedDocument.serviceProviderPay?.service_name}
                  </div>
                  <div className="col-md-4 text-end">
                    <strong>Provider:</strong> {selectedDocument.provider?.company_name}
                  </div>
                </div>

                {/* Row for Duration and Amount */}
                <div className="row mt-3 text-center">
                  <div className="col-md-6 text-start">
                    <strong>Plan Duration:</strong> {selectedDocument?.start_date} - {selectedDocument?.end_date}
                  </div>
                  <div className="col-md-6 text-end">
                    <strong>Amount:</strong> ${selectedDocument?.amount}
                  </div>
                </div>

                {clientAppointmentNotes && clientAppointmentNotes.length > 0 ? (
                  <div className="space-y-4">
                    {clientAppointmentNotes.map((note) => {
                      const documentList = note.documents
                      ? note.documents.split(',').map(doc => doc.trim()).filter(Boolean)
                      : [];

                      const documentBaseUrl = process.env.REACT_APP_ATTACHMENT_NOTES_IMAGE_BACKEND_URL;

                      return (
                        <div
                          key={note.id}
                          className="border p-3 rounded-md shadow-sm bg-light mt-4"
                        >
                          {/* First Line: Date + Present */}
                          <div className="d-flex justify-content-between mb-2">
                            <span><strong>Date:</strong> {note.date_of_appointment}</span>
                            <span><strong>Present:</strong> {note.present}</span>
                          </div>

                          {/* Notes Paragraph */}
                          <div className="mb-2">
                            <span><strong>Notes: </strong> {note.notes} </span>
                            {/* <p className="mb-1 mt-2">{note.notes}</p> */}
                          </div>

                          {/* Document Link */}
                          {documentList.length > 0 && (
                          <div>
                            <strong>Documents:</strong>
                            <ul className="mb-0 mt-2">
                              {documentList.map((doc, idx) => (
                                <li key={idx} className="mt-2">
                                  <a
                                    href={`${documentBaseUrl}/${doc}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    View Document {idx + 1}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <p className="mt-4">No appointment notes found.</p>
                )}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
    </>
  );
};

export default ClientListPayment;